import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { AngularFirestore } from '@angular/fire/firestore';
import { JsontocsvService } from 'app/utility/services/jsontocsv.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-beatboxing',
  templateUrl: './beatboxing.component.html',
  styleUrls: ['./beatboxing.component.css']
})
export class BeatboxingComponent implements OnInit {
  dataSource;
  data;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private afs: AngularFirestore, private j2c: JsontocsvService) { }

  ngOnInit() {
    this.afs.collection('beatboxing').valueChanges().subscribe(
      (res) => {
        this.data = res;
        this.dataSource = new MatTableDataSource(Object.keys(res).map(k => res[k]));
        this.dataSource.paginator = this.paginator;
      }
    );
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  excel() {
   this.j2c.excel(this.data);
  }
}
